import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["timeout", "placement", "showTimeout", "hideTimeout"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useMemo } from 'react';
import { usePopoverState } from '../popover/popover-state.js';
/**
 * Provides state for the `Hovercard` components.
 * @example
 * ```jsx
 * const hovercard = useHovercardState({ placement: "top" });
 * <HovercardAnchor state={hovercard}>@username</HovercardAnchor>
 * <Hovercard state={hovercard}>Details</Hovercard>
 * ```
 */

function useHovercardState(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 500 : _ref$timeout,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "bottom" : _ref$placement,
      _ref$showTimeout = _ref.showTimeout,
      showTimeout = _ref$showTimeout === void 0 ? timeout : _ref$showTimeout,
      _ref$hideTimeout = _ref.hideTimeout,
      hideTimeout = _ref$hideTimeout === void 0 ? timeout : _ref$hideTimeout,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      autoFocusOnShow = _useState2[0],
      setAutoFocusOnShow = _useState2[1];

  var popover = usePopoverState(_objectSpread({
    placement: placement
  }, props));
  var state = useMemo(function () {
    return _objectSpread(_objectSpread({}, popover), {}, {
      timeout: timeout,
      showTimeout: showTimeout,
      hideTimeout: hideTimeout,
      autoFocusOnShow: autoFocusOnShow,
      setAutoFocusOnShow: setAutoFocusOnShow
    });
  }, [popover, timeout, showTimeout, hideTimeout, autoFocusOnShow, setAutoFocusOnShow]);
  return state;
}

export { useHovercardState };